const translations = {
  button: {
    agree: 'Souhlasím',
    next: 'Další volby',
    continue: 'Pokračovat',
    editSettings: 'Upravit nastavení',
    back: 'Zpět',
    details: 'Podrobné nastavení',
    confirm: 'Potvrdit nastavení',
    collapseClose: 'Zobrazit méně',
    collapseOpen: 'Zobrazit více >>',
    purposes: 'Zobrazit všechny účely >>',
    here: 'zde',
    edit: 'upravit'
  },
  intro: {
    title: 'Nastavení souhlasu s&nbsp;personalizací',

    subTitle: 'Díky zobrazování reklam vám můžeme nabízet kvalitní obsah <b>zadarmo</b>',

    subTitleContinue: 'Vaše nastavení souhlasů již máme uložené. Pokud jej nechcete měnit, klikněte na tlačítko „Pokračovat“.',

    description1: `Společnost Seznam.cz, a.s. shromažďuje, uchovává a&nbsp;sdílí informace o&nbsp;koncových uživatelích, včetně IP adres,
      jedinečných identifikátorů uživatelů nebo informací umožňujících osobní identifikaci získané na našich stránkách,
      i&nbsp;na stránkách našich partnerů, se kterými jsme propojeni. Podrobné informace o&nbsp;nakládání s&nbsp;osobními údaji najdete
      na <a href="https://o.seznam.cz/ochrana-udaju/personalizace-obsahu-a-reklamy/" target="_blank">stránkách o&nbsp;ochraně osobních údajů</a>.`,

    description11: `Prosíme vás proto o&nbsp;potvrzení, že pro účely poskytování jedinečného obsahu (zejména článků, počasí, výsledků vyhledávání,
      zajímavých tipů a&nbsp;reklamních sdělení) na internetových stránkách a&nbsp;v&nbsp;mobilních aplikacích našich služeb poskytujete společnosti Seznam.cz, a.s
      výslovný souhlas se zpracováním svých osobních údajů (například identifikátoru cookie), jejich využitím pro účely předpokládané právními předpisy
      (ukládání a&nbsp;zpracování, měření, personalizace, doporučování obsahu a&nbsp;reklamních sdělení) a&nbsp;jejich možným sdílením s&nbsp;našimi`,

    description2: '. Údaje pro účely měření a&nbsp;ukládání zpracovává Seznam.cz na základě oprávněného zájmu.',

    description2Logged:
      ' Nastavení soukromí můžete kdykoliv změnit ve svém <a href="https://profil.seznam.cz/gdpr" target="_blank">Profilu</a>.',

    description2Unlogged: ' Nastavení soukromí můžete kdykoliv změnit na stránkách o ochraně osobních údajů.',

    description22: 'Rozsah uděleného souhlasu můžete upravit kliknutím na tlačítko „Další volby“.',

    descriptionPrev1: `Společnost Seznam.cz, a.s shromažďuje, uchovává a&nbsp;sdílí informace o&nbsp;koncových 
      uživatelích, včetně IP adres, jedinečných identifikátorů uživatelů nebo 
      informací umožňujících osobní identifikaci získané na našich stránkách, i&nbsp;na 
      stránkách našich partnerů, se kterými jsme propojeni.  Podrobné informace o&nbsp;nakládání
      s&nbsp;osobními údaji najdete <a href="https://o.seznam.cz/ochrana-udaju/personalizace-obsahu-a-reklamy/" target="_blank">na stránkách o&nbsp;ochraně osobních údajů</a>.`,

    descriptionPrev11: `Aktualizovali jsme znění souhlasu a&nbsp;rozšířili jsme možnosti nastavení &ndash; nově
      můžete vybrat, se kterými partnery můžeme sdílet údaje. Prosíme vás proto o&nbsp;aktualizaci vašeho 
      souhlasu, že pro účely poskytování jedinečného obsahu (zejména článků, počasí, výsledků 
      vyhledávání, zajímavých tipů a&nbsp;reklamních sdělení) na internetových stránkách a&nbsp;v&nbsp;mobilních 
      aplikacích našich služeb poskytujete společnosti Seznam.cz, a.s výslovný souhlas se zpracováním 
      svých osobních údajů (například identifikátoru cookie), jejich využitím pro účely předpokládané právními předpisy 
      (ukládání a&nbsp;zpracování, měření, personalizace, doporučování obsahu a&nbsp;reklamních sdělení) 
      a&nbsp;jejich možným sdílením s&nbsp;našimi`,

    descriptionPrev2: '. Údaje pro účely měření a&nbsp;ukládání zpracovává Seznam.cz na základě oprávněného zájmu.',

    descriptionPrev2Logged:
      ' Nastavení soukromí můžete kdykoliv změnit ve svém <a href="https://profil.seznam.cz/gdpr" target="_blank">Profilu</a>.',

    descriptionPrev2Unlogged: ' Nastavení soukromí můžete kdykoliv změnit na stránkách o ochraně osobních údajů.',

    descriptionPrev22: 'Rozsah uděleného souhlasu můžete upravit kliknutím na tlačítko „Další volby“.',

    simpleDialog:
      'Podrobné informace o nakládání s osobními údaji najdete na <a href="https://o.seznam.cz/ochrana-udaju/personalizace-obsahu-a-reklamy/" target="_blank">stránkách o ochraně osobních údajů</a>.',

    vendorButton: 'vybranými partnery',

    external: {
      description1: `Provozovatel tohoto webu a společnost Seznam.cz, a.s. shromažďuje, uchovává a sdílí informace o&nbsp;koncových uživatelích, včetně IP adres, 
        jedinečných identifikátorů uživatelů nebo informací umožňujících osobní identifikaci získané na našich stránkách, 
        i&nbsp;na stránkách našich partnerů, se kterými jsme propojeni. Podrobné informace o&nbsp;nakládání s&nbsp;osobními údaji najdete 
        na stránkách o&nbsp;ochraně osobních údajů.<br />
        Na internetových stránkách, které jsou součástí partnerské sítě 
        společnosti Seznam.cz, a.s. můžete dostávat obsah a nabídky, které vás skutečně baví a zajímají. 
        K&nbsp;tomu potřebujeme váš souhlas se zpracováním osobních údajů v&nbsp;souladu s&nbsp;celoevropským nařízením GDPR.`,

      description11: `Prosíme vás proto o&nbsp;potvrzení, že pro účely poskytování jedinečného obsahu 
        (zejména článků, počasí, výsledků vyhledávání, zajímavých tipů a reklamních sdělení) na internetových stránkách 
        a v&nbsp;mobilních aplikacích partnerské sítě společnosti Seznam.cz, a.s. poskytujete reklamnímu systému 
        společnosti Seznam.cz, a.s., provozovatelům internetových stránek, kteří jsou součástí 
        <a href="https://partner.seznam.cz/ochrana-soukromi/zapojene-weby" target="_blank">partnerské sítě</a> 
        společnosti Seznam.cz, a.s., případně`,

      description2: ` výslovný souhlas se zpracováním svých osobních údajů, jejich využitím pro účely předpokládané 
        právními předpisy (ukládání a zpracování, měření, personalizace, doporučování obsahu a reklamních sdělení) 
        a jejich možným sdílením v&nbsp;rámci partnerské sítě společnosti Seznam.cz, a.s. Údaje pro účely měření a&nbsp;ukládání 
        zpracovává Seznam.cz na základě oprávněného zájmu. Nastavení soukromí můžete 
        kdykoliv změnit na stránkách o&nbsp;ochraně osobních údajů.`,

      description22: 'Rozsah uděleného souhlasu můžete upravit kliknutím na tlačítko „Další volby“.',

      descriptionPrev1: `Provozovatel tohoto webu a společnost Seznam.cz, a.s shromažďuje, uchovává a sdílí informace o&nbsp;koncových uživatelích, včetně IP adres, 
        jedinečných identifikátorů uživatelů nebo informací umožňujících osobní identifikaci získané na našich stránkách, 
        i&nbsp;na stránkách našich partnerů, se kterými jsme propojeni. Podrobné informace o&nbsp;nakládání s&nbsp;osobními údaji najdete 
        na stránkách o&nbsp;ochraně osobních údajů.<br />
        Na internetových stránkách, které jsou součástí partnerské sítě 
        společnosti Seznam.cz, a.s. můžete dostávat obsah a nabídky, které vás skutečně baví a zajímají. 
        K&nbsp;tomu potřebujeme váš souhlas se zpracováním osobních údajů v&nbsp;souladu s&nbsp;celoevropským nařízením GDPR.`,

      descriptionPrev11: `Prosíme vás proto o&nbsp;potvrzení, že pro účely poskytování jedinečného obsahu 
        (zejména článků, počasí, výsledků vyhledávání, zajímavých tipů a reklamních sdělení) na internetových stránkách 
        a v&nbsp;mobilních aplikacích partnerské sítě společnosti Seznam.cz, a.s. poskytujete reklamnímu systému 
        společnosti Seznam.cz, a.s., provozovatelům internetových stránek, kteří jsou součástí 
        <a href="https://partner.seznam.cz/ochrana-soukromi/zapojene-weby" target="_blank">partnerské sítě</a> 
        společnosti Seznam.cz, a.s., případně`,

      descriptionPrev2: ` výslovný souhlas se zpracováním svých osobních údajů, jejich využitím pro účely předpokládané 
        právními předpisy (ukládání a zpracování, měření, personalizace, doporučování obsahu a reklamních sdělení) 
        a jejich možným sdílením v&nbsp;rámci partnerské sítě společnosti Seznam.cz, a.s. Údaje pro účely měření a&nbsp;ukládání 
        zpracovává Seznam.cz na základě oprávněného zájmu. Nastavení soukromí můžete 
        kdykoliv změnit na stránkách o&nbsp;ochraně osobních údajů.`,

      descriptionPrev22: 'Rozsah uděleného souhlasu můžete upravit kliknutím na tlačítko „Další volby“.',

      vendorButton: 'vybraným partnerům'
    },

    seznamBrowserMessage: `Zobrazuje se Vám žádost o&nbsp;udělení souhlasu příliš často?<br>
    Přejděte na chytrý <a href="https://www.seznam.cz/prohlizec/?sourceId=53" target="_blank">prohlížeč od Seznam.cz</a>, aby pro vás používání našich služeb bylo pohodlnější.`
  },
  vendors: {
    title: 'Podrobné nastavení',
    description:
      'Vaše údaje budou moci užívat námi vybrané společnosti \
    k níže popsaným účelům. Pomocí zaškrtávátek můžete nastavit, kterým \
    společnostem povolujete předávání informací. Pokud jste u některého účelu vyslovili nesouhlas, nebude vaše údaje pro tento účel používat <b>žádný</b> z partnerů. \
    Nastavení partnerů tedy využijte v případě, že s personalizovaným obsahem či personalizovanou reklamou souhlasíte, ale přejete si je omezit jen na některé partnery.',

    externalDescription: `Vaše údaje budou reklamní systém společnosti Seznam.cz, a.s., provozovatelé internetových stránek, 
      kteří jsou součástí partnerské sítě společnosti Seznam.cz, a.s., případně vybraní partneři oprávněni užívat k&nbsp;níže 
      popsaným účelům. Pomocí zaškrtávátek můžete nastavit, kterým společnostem povolujete předávání informací. 
      Pokud jste u&nbsp;některého účelu vyslovili nesouhlas, nebude vaše údaje pro tento účel používat <b>žádný</b> z&nbsp;partnerů. 
      Nastavení partnerů tedy využijte v&nbsp;případě, že s&nbsp;personalizovaným obsahem či personalizovanou reklamou 
      souhlasíte, ale přejete si je omezit jen na některé partnery.`,

    details: `
      <b>
        <span class="scmp_icon-p-grey-1"></span>
        Uložení informací a přístup k nim
      </b>
      <p>Uložení informací na vašem zařízení nebo přístup k informacím, které jsou na něm již uloženy, jako jsou reklamní identifikátory,
      identifikátory zařízení, soubory cookie a podobné technologie.</p>

      <b>
        <span class="scmp_icon-p-grey-2"></span>
        Personalizace
      </b>
      <p>Shromažďování a zpracovávání informací o používání této služby z vaší strany pro následnou průběžnou personalizaci reklamy a/nebo
      obsahu pro vaši osobu v jiných souvislostech, například na jiných webových stránkách nebo v jiných aplikacích. Obsah webové stránky
      nebo aplikace se zpravidla použije pro odvození vašich zájmů, na jejichž základě probíhá výběr reklamy nebo obsahu v budoucnu.</p>

      <b>
        <span class="scmp_icon-p-grey-3"></span>
        Výběr, zobrazování a reporting reklamy
      </b>
      <p>Shromažďování informací a jejich slučování s informacemi shromážděnými dříve za účelem výběru a zobrazování reklam pro vaši osobu
      a měření zobrazování a účinnosti takových reklam. Patří sem použití dříve shromážděných informací o vašich zájmech pro výběr reklam,
      zpracování údajů o zobrazených reklamách, o frekvenci, času a místě jejich zobrazení a o tom, zda jste v souvislosti s danou reklamou
      provedli nějaké kroky, například kliknutí na reklamu nebo provedení nákupu. Nepatří sem personalizace, která představuje shromažďování
      a zpracovávání informací o používání této služby z vaší strany pro následnou průběžnou personalizaci reklamy a/nebo obsahu pro vaši osobu
      v jiných souvislostech, například na webových stránkách nebo v aplikacích.</p>

      <b>
        <span class="scmp_icon-p-grey-4"></span>
        Výběr, zobrazování a reporting obsahu
      </b>
      <p>Shromažďování informací a jejich slučování s informacemi shromážděnými dříve za účelem výběru a zobrazování obsahu pro vaši osobu
      a měření zobrazování a účinnosti takového obsahu. Patří sem použití dříve shromážděných informací o vašich zájmech pro výběr obsahu,
      zpracování údajů o zobrazeném obsah, o frekvenci, času a místě jejich zobrazení a o tom, zda jste v souvislosti s daným obsahem provedli
      nějaké kroky, například kliknutí na obsah. Nepatří sem personalizace, která představuje shromažďování a zpracovávání informací o používání
      této služby z vaší strany pro následnou průběžnou personalizaci obsahu a/nebo reklamy pro vaši osobu v jiných souvislostech,
      například na webových stránkách nebo v aplikacích.</p>

      <b>
        <span class="scmp_icon-p-grey-5"></span>
        Měření
      </b>
      <p>Shromažďování informací o používání obsahu z vaší strany a jejich slučování s informacemi shromážděnými dříve za účelem měření,
      porozumění a reportingu používání služby z vaší strany. Nepatří sem personalizace, shromažďování informací o používání této služby
      z vaší strany pro následnou průběžnou personalizaci obsahu a/nebo reklamy pro vaši osobu v jiných souvislostech, tj. u jiné služby,
      například na webových stránkách nebo v aplikacích.</p>

      <b>
        <span class="scmp_icon-f-grey-1"></span>
        Párování off-line údajů
      </b>
      <p>
        Slučování údajů z off-line zdrojů, které byly původně shromážděny v jiných souvislostech, s údaji shromážděnými online jako podklad pro jeden nebo více účelů.
      </p>

      <b>
        <span class="scmp_icon-f-grey-2"></span>
        Propojování zařízení
      </b>
      <p>
        Zpracovávání údajů za účelem propojení více zařízení, jež náleží stejnému uživateli, jako podklad pro jeden nebo více účelů.
      </p>

      <b>
        <span class="scmp_icon-f-grey-3"></span>
        Údaje o přesné zeměpisné poloze
      </b>
      <p>
        Shromažďování a podpora údajů o přesné zeměpisné poloze jako podklad pro jeden nebo více účelů.
      </p>
    `,
    help: `
    U každého partnera jsou jednotlivé účely vyznačeny příslušným symbolem. <strong class="scmp_VendorsText-purpose">Černou barvou</strong> jsou zobrazeny účely, 
    pro které partner potřebuje souhlas, <strong class="scmp_VendorsText-purpose">šedou barvou</strong> účely, které partner označuje za oprávněný zájem.
    `
  },
  purposes: {
    title: 'Nastavení soukromí',
    description:
      'Společnost Seznam.cz, a.s. a případně vybrané partnerské \
    společnosti mohou mít přístup k níže uvedeným informacím a s vaším souhlasem \
    je užívat ke konkrétním účelům. Pomocí níže uvedeného seznamu je \
    můžete upravit a vaši volbu potvrdit tlačítkem níže. Více informací \
    o ochraně osobních údajů najdete na <b><a href="https://o.seznam.cz/ochrana-udaju/" target="_blank">našem webu</a></b>.',

    changeSettingsLogged:
      ' Nastavení soukromí můžete kdykoliv změnit ve svém <b><a href="https://profil.seznam.cz/gdpr" target="_blank">Profilu</a></b>.',

    changeSettingsUnlogged: ' Nastavení soukromí můžete kdykoliv změnit na stránkách o ochraně osobních údajů.',

    descriptionExternal: `Společnost Seznam.cz, a.s., provozovatelé internetových stránek, které jsou součástí její partnerské sítě, 
      případně vybraní partneři mohou mít přístup k&nbsp;níže uvedeným informacím a s&nbsp;vaším souhlasem je užívat ke konkrétním účelům. 
      Pomocí níže uvedeného seznamu je můžete upravit a vaši volbu potvrdit tlačítkem níže. Více informací o&nbsp;ochraně osobních údajů 
      společnosti Seznam.cz, a.s. najdete <a href="https://o.seznam.cz/ochrana-udaju/" target="_blank">zde</a>.`,
    personalizeContent: {
      title: 'Personalizace obsahu',
      description:
        'Shromažďování informací a jejich kombinace s dříve shromážděnými informacemi za účelem výběru a zobrazení obsahu a analýzy jeho zobrazování a efektivity.',
      details: `
        <b>Souhlas se zpracováním osobních údajů k obsahu ušitému na míru</b>
        <p>
          Seznam.cz, a.s. (jako správce osobních údajů) Vám může na svých
          internetových stránkách, stránkách našich partnerů a mobilních
          aplikacích zobrazovat a doporučovat obsah na základě vašich zájmů -
          jedná se především o články, počasí či výsledky vyhledávání.
        </p>
        <p>
          Abychom Vám mohli tento obsah šitý na míru každého unikátního uživatele
          služeb společnosti Seznam.cz, a.s nabízet, je nutné
          <b>propojit</b>
          Váš
          <b>účet</b>
          u společnosti Seznam.cz, a.s, do něhož se přihlašujete prostřednictvím e-mailové
          adresy a hesla (účet obsahuje Vámi zadané osobní údaje a užíváte jej na základě
          odsouhlasených smluvních podmínek) a <b>anonymizovaná data</b> o chování internetového
          prohlížeče, případně všech vámi využívaných prohlížečů, kterými se do účtu přihlašuje,
          na navštívených internetových stránkách a způsobu jejich využívání
          (jedná se o technické a lokalizační údaje o internetovém prohlížeči,
          které zpracováváme jen po nezbytnou dobu, nejdéle však 30 dní).
        </p>
        <p>
          Pokud máte o unikátní personalizovaný obsah zájem, udělujete tímto
          společnosti Seznam.cz, a.s souhlas s propojením Vašeho uživatelského účtu u
          společnosti Seznam.cz, a.s s anonymními daty o chování vašeho internetového
          prohlížeče na navštívených internetových stránkách a způsobu jejich
          využívání
        </p>
        <b>
            Na základě obecného nařízení o ochraně osobních údajů (známého pod
            zkratkou GDPR) můžete:
          </b>
        <ul>
          <li>kdykoli odvolat souhlas se zpracováním osobních údajů;</li>
          <li>mít přístup ke svým osobním údajům;</li>
          <li>opravit nebo vymazat vlastní osobní údaje;</li>
          <li>omezit zpracování osobních údajů;</li>
          <li>
            přenést osobní údaje ve strukturovaném, běžně používaném a strojově
            čitelném formátu;
          </li>
          <li>podat stížnost u dozorového Úřadu pro ochranu osobních údajů</li>
          <li>
            odmítnout rozhodnutí založené výhradně na automatizovaném zpracování;
          </li>
        </ul>
        <p>
          Podrobnější informace o nakládání s osobními údaji najdete na stránkách
          společnosti Seznam.cz, a.s (
          <a target="_blank" href="https://www.seznam.cz/ochrana-udaju/">
            https://www.seznam.cz/ochrana-udaju/
          </a>
          ).
        </p>
      `,
      detailsUnlogged: `
        <b>Souhlas se zpracováním osobních údajů k obsahu ušitému na míru</b>
        <p>
          Seznam.cz, a.s. (jako správce osobních údajů) Vám může na svých
          internetových stránkách, stránkách našich partnerů a mobilních
          aplikacích zobrazovat a doporučovat obsah na základě vašich zájmů -
          jedná se především o články, počasí či výsledky vyhledávání.
        </p>
        <p>
        Abychom Vám mohli tento obsah šitý na míru každého unikátního uživatele
        služeb společnosti Seznam.cz, a.s nabízet, využíváme data o chování internetového
        prohlížeče, případně všech vámi využívaných prohlížečů, na navštívených internetových
        stránkách a způsobu jejich využívání (jedná se o technické a lokalizační údaje o internetovém
        prohlížeči, které zpracováváme jen po nezbytnou dobu, nejdéle však 30 dní).

        </p>
        <p>
        Pokud máte o unikátní personalizovaný obsah zájem, udělujete tímto reklamnímu
        systému společnosti Seznam.cz, a.s a partnerské síti souhlas s využíváním dat o chování
        vašeho internetového prohlížeče na navštívených internetových stránkách a způsobu jejich využívání.

        </p>
        <b>
            Na základě obecného nařízení o ochraně osobních údajů (známého pod
            zkratkou GDPR) můžete:
          </b>
        <ul>
          <li>kdykoli odvolat souhlas se zpracováním osobních údajů;</li>
          <li>mít přístup ke svým osobním údajům;</li>
          <li>opravit nebo vymazat vlastní osobní údaje;</li>
          <li>omezit zpracování osobních údajů;</li>
          <li>
            přenést osobní údaje ve strukturovaném, běžně používaném a strojově
            čitelném formátu;
          </li>
          <li>podat stížnost u dozorového Úřadu pro ochranu osobních údajů</li>
          <li>
            odmítnout rozhodnutí založené výhradně na automatizovaném zpracování;
          </li>
        </ul>
        <p>
          Podrobnější informace o nakládání s osobními údaji najdete na stránkách
          společnosti Seznam.cz, a.s (
          <a target="_blank" href="https://www.seznam.cz/ochrana-udaju/">
            https://www.seznam.cz/ochrana-udaju/
          </a>
          ).
        </p>
      `,
      detailsExternal: `
        <b>Souhlas se zpracováním osobních údajů k&nbsp;obsahu ušitému na míru</b>
        <p>
          Na internetových stránkách, které jsou součástí partnerské sítě 
          společnosti Seznam.cz, a.s. je možné zobrazovat a doporučovat obsah na základě vašich zájmů. Jedná se především o&nbsp;články, počasí atd.
        </p>
        <p>
          Abychom Vám mohli tento obsah šitý na míru každého unikátního uživatele 
          nabízet, jsou využívány data o&nbsp;chování internetového prohlížeče, 
          případně všech vámi využívaných prohlížečů, na navštívených internetových 
          stránkách a způsobu jejich využívání (jedná se o&nbsp;technické a lokalizační 
          údaje o&nbsp;internetovém prohlížeči, které zpracováváme jen po nezbytnou dobu, nejdéle však 30 dní).
        </p>
        <p>
          Pokud máte o&nbsp;unikátní personalizovaný obsah zájem, udělujete tímto reklamnímu 
          systému společnosti Seznam.cz, a.s. a provozovatelům internetových stránek, 
          kteří jsou součástí partnerské sítě společnosti Seznam.cz, a.s. výslovný 
          souhlas s využíváním dat o&nbsp;chování vašeho internetového prohlížeče na 
          navštívených internetových stránkách a způsobu jejich využívání.
        </p>
        <b>
          Na základě obecného nařízení o&nbsp;ochraně osobních údajů (známého pod zkratkou GDPR) můžete:
        </b>
        <ul>
          <li>kdykoli odvolat souhlas se zpracováním osobních údajů;</li>
          <li>mít přístup ke svým osobním údajům;</li>
          <li>opravit nebo vymazat vlastní osobní údaje;</li>
          <li>omezit zpracování osobních údajů;</li>
          <li>přenést osobní údaje ve strukturovaném, běžně používaném a strojově čitelném formátu;</li>
          <li>podat stížnost u&nbsp;dozorového Úřadu pro ochranu osobních údajů</li>
          <li>odmítnout rozhodnutí založené výhradně na automatizovaném zpracování;</li>
        </ul>
        <p>
          Podrobnější informace o&nbsp;nakládání s&nbsp;osobními údaji najdete na stránkách
          společnosti Seznam.cz, a.s (
          <a target="_blank" href="https://www.seznam.cz/ochrana-udaju/">
            https://www.seznam.cz/ochrana-udaju/
          </a>
          ).
        </p>
      `
    },
    personalizeAds: {
      title: 'Personalizace reklamy',
      description: `Shromažďování a zpracování informací o&nbsp;využívání služeb naší
        společnosti a našich partnerů pro následné přizpůsobení reklamy na dalších webových stránkách
        a aplikacích. Údaje mohou být předávány našim partnerům.`,
      details1: `
        <b>Souhlas se zpracováním osobních údajů k reklamě ušité na míru</b>
        <p>
          Seznam.cz, a.s. (jako správce osobních údajů) provozuje vlastní reklamní systém,
          díky kterému vám můžeme nabídnout reklamu na základě vašich zájmů. Můžete se tak
          dozvědět o produktech či službách, které se Vám budou skutečně hodit.
        </p>
        <p>
          Abychom Vám mohli tento obsah šitý na míru každého unikátního uživatele služeb
          společnosti Seznam.cz, a.s nabízet, je nutné propojit Váš účet u společnosti Seznam.cz, a.s,
          do něhož se přihlašujete prostřednictvím e-mailové adresy a hesla (účet obsahuje Vámi
          zadané osobní údaje a užíváte jej na základě odsouhlasených smluvních podmínek)
          a anonymizovaná data o chování vašeho internetového prohlížeče na navštívených
          internetových stránkách a způsobu jejich využívání (jedná se o technické a lokalizační
          údaje o internetovém prohlížeči, které zpracováváme jen po nezbytnou dobu, nejdéle však 30 dní).
        </p>
        <p>
          Pokud máte zájem o reklamu personalizovanou dle Vaši zájmů, udělujete tímto společnosti Seznam.cz, a.s
          souhlas s propojením Vašeho uživatelského účtu u společnosti Seznam.cz, a.s s anonymními daty o chování
          internetového prohlížeče na navštívených internetových stránkách a způsobu jejich využívání
        </p>`,
      detailsUnlogged1: `
        <b>Souhlas se zpracováním osobních údajů k reklamě ušité na míru</b>
        <p>
          Seznam.cz, a.s. (jako správce osobních údajů) provozuje vlastní reklamní systém,
          díky kterému vám můžeme nabídnout reklamu na základě vašich zájmů. Můžete se tak
          dozvědět o produktech či službách, které se Vám budou skutečně hodit.
        </p>
        <p>
        Abychom Vám mohli tento obsah šitý na míru každého unikátního uživatele služeb
        partnerské sítě společnosti Seznam.cz, a.s nabízet, využíváme data o chování vašeho
        internetového prohlížeče, případně všech vámi využívaných prohlížečů, na navštívených
        internetových stránkách a způsobu jejich využívání (jedná se o technické a lokalizační
        údaje o internetovém prohlížeči, které zpracováváme jen po nezbytnou dobu, nejdéle však 30 dní).
        </p>
        <p>
        Pokud máte zájem o reklamu personalizovanou dle Vaši zájmů, udělujete tímto reklmanímu systému
        společnosti Seznam.cz, a.s a partnerské síti souhlas  s využíváním dat  o chování internetového
        prohlížeče na navštívených internetových stránkách a způsobu jejich využívání

        </p>`,
      details11: `Námi vybrané společnosti mohou mít přístup k informacím o vašich preferovaných zájmech a mohou vás
        také oslovovat s cílenou reklamou. Pomocí seznamu uvedeného`,
      details2: `je můžete upravit. Vybraným partnerům
        můžeme poskytnout pouze odhadované statistiky chování (např. žena, 50 - 60 let, se zájmem o vaření
        z Královehradeckého kraje).`,
      details22: `
        <p><b>
          Na základě obecného nařízení o ochraně osobních údajů (známého pod zkratkou GDPR) můžete:
        </b></p>
        <ul>
          <li>kdykoli odvolat souhlas se zpracováním osobních údajů;</li>
          <li>mít přístup ke svým osobním údajům;</li>
          <li>opravit nebo vymazat vlastní osobní údaje;</li>
          <li>omezit zpracování osobních údajů;</li>
          <li>
            přenést osobní údaje ve strukturovaném, běžně používaném a strojově
            čitelném formátu;
          </li>
          <li>podat stížnost u dozorového Úřadu pro ochranu osobních údajů</li>
          <li>
            odmítnout rozhodnutí založené výhradně na automatizovaném zpracování;
          </li>
        </ul>
        <p>
          Podrobnější informace o nakládání s osobními údaji najdete na stránkách
          společnosti Seznam.cz, a.s (
          <a target="_blank" href="https://www.seznam.cz/ochrana-udaju/">
            https://www.seznam.cz/ochrana-udaju/
          </a>
          ).
        </p>
      `,
      detailsExternal: `
        <b>Souhlas se zpracováním osobních údajů k&nbsp;reklamě ušité na míru</b>
        <p>
          Na internetových stránkách, které jsou součástí partnerské sítě 
          společnosti Seznam.cz, a.s. je možné nabídnout reklamu na základě 
          vašich zájmů. Můžete se tak dozvědět o&nbsp;produktech či službách, 
          které se Vám budou skutečně hodit.
        </p>
        <p>
          Abychom Vám mohli tento obsah šitý na míru každého unikátního uživatele služeb 
          partnerské sítě společnosti Seznam.cz, a.s nabízet, jsou využívány data o&nbsp;chování 
          internetového prohlížeče, případně všech vámi využívaných prohlížečů, na navštívených 
          internetových stránkách a způsobu jejich využívání (jedná se o&nbsp;technické a 
          lokalizační údaje o&nbsp;internetovém prohlížeči, které zpracováváme 
          jen po nezbytnou dobu, nejdéle však 30 dní).
        </p>
        <p>
          Pokud máte o&nbsp;reklamu personalizovanou dle vašich zájmů zájem, udělujete tímto reklamnímu 
          systému společnosti Seznam.cz, a.s., provozovatelům internetových stránek, kteří jsou 
          součástí partnerské sítě společnosti Seznam.cz, a.s., a partnerské síti výslovný souhlas s 
          využíváním dat o&nbsp;chování vašeho internetového prohlížeče na navštívených internetových 
          stránkách a způsobu jejich využívání.
        </p>
        <p>
          Námi vybrané společnosti mohou mít přístup k informacím o&nbsp;vašich preferovaných zájmech 
          a mohou vás také oslovovat s cílenou reklamou. Pomocí seznamu uvedeného v 
          Podrobném nastavení (odkaz v horní části) je můžete upravit. 
          Vybraným partnerům můžeme poskytnout pouze odhadované statistiky chování 
          (např. žena, 50 - 60 let, se zájmem o&nbsp;vaření z Královehradeckého kraje).
        </p>
        <p><b>
          Na základě obecného nařízení o&nbsp;ochraně osobních údajů (známého pod zkratkou GDPR) můžete:
        </b></p>
        <ul>
          <li>kdykoli odvolat souhlas se zpracováním osobních údajů;</li>
          <li>mít přístup ke svým osobním údajům;</li>
          <li>opravit nebo vymazat vlastní osobní údaje;</li>
          <li>omezit zpracování osobních údajů;</li>
          <li>
            přenést osobní údaje ve strukturovaném, běžně používaném a strojově
            čitelném formátu;
          </li>
          <li>podat stížnost u dozorového Úřadu pro ochranu osobních údajů</li>
          <li>
            odmítnout rozhodnutí založené výhradně na automatizovaném zpracování;
          </li>
        </ul>
        <p>
          Podrobnější informace o&nbsp;nakládání s&nbsp;osobními údaji najdete na stránkách
          společnosti Seznam.cz, a.s (
          <a target="_blank" href="https://www.seznam.cz/ochrana-udaju/">
            https://www.seznam.cz/ochrana-udaju/
          </a>
          ).
        </p>
      `
    }
  }
};

export default translations;
